var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.567 4.03.014.014 5.625 5.625c.095.094.141.22.138.344v.018a.5.5 0 0 1-.303.468l-5.46 5.457a.469.469 0 0 1-.676-.648l.014-.014 4.76-4.763H3.125c-.259 0-.469-.224-.469-.5 0-.27.2-.49.451-.5h12.636L10.92 4.706a.469.469 0 0 1-.014-.648l.014-.014a.469.469 0 0 1 .648-.014Z",
    fill: "#000"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0b0b5a8b.svg";
export { ForwardRef as ReactComponent };